import SentryErrorBoundary from './SentryErrorBoundary';

export { ErrorBoundary } from './ErrorBoundary';

export default SentryErrorBoundary;
